import React from "react";
import Text from "../questionTypes/Text";
import Date from "../questionTypes/Date";
import MultiChoice from "../questionTypes/MultiChoice";
import Number from "../questionTypes/Number";
import MatrixSingleChoice from "../questionTypes/MatrixSingleChoice";
import Table from "../questionTypes/TableQuestion.js";
import Upload from "../questionTypes/Upload";
import { FormattedMessage } from "react-intl";
import { Alert } from "react-bootstrap";

export const ProjectData = () => (
  <Alert variant="info">
    <FormattedMessage id="survey.editor.toolbox.projectData.hint" />
  </Alert>
);

const questionTypes = [
  {
    type: "text",
    component: <Text />,
    toolboxComponent: "survey.editor.toolbox.text"
  },
  {
    type: "comment",
    component: <Text />,
    toolboxComponent: "survey.editor.toolbox.comment"
  },
  {
    type: "infoMessage",
    component: <Text />,
    toolboxComponent: "survey.editor.toolbox.infoMessage"
  },
  {
    type: "checkbox",
    component: <MultiChoice />,
    toolboxComponent: "survey.editor.toolbox.checkbox"
  },
  {
    type: "radio",
    component: <MultiChoice />,
    toolboxComponent: "survey.editor.toolbox.radio"
  },
  {
    type: "dropdown",
    component: <MultiChoice />,
    toolboxComponent: "survey.editor.toolbox.dropdown",
    excludeFromToolbox: true
  },
  {
    type: "predefinedList",
    component: <MultiChoice />,
    toolboxComponent: "survey.editor.toolbox.predefinedList",
    excludeFromToolbox: true
  },
  {
    type: "number",
    component: <Number />,
    toolboxComponent: "survey.editor.toolbox.number"
  },
  {
    type: "matrixSingleChoice",
    component: <MatrixSingleChoice />,
    toolboxComponent: "survey.editor.toolbox.matrixChoice"
  },
  {
    type: "matrixMultipleChoice",
    component: <MatrixSingleChoice />,
    toolboxComponent: "survey.editor.toolbox.matrixChoice",
    excludeFromToolbox: true
  },
  {
    type: "date",
    component: <Date />,
    toolboxComponent: "survey.editor.toolbox.date"
  },
  {
    type: "staticTable",
    component: <Table />,
    toolboxComponent: "survey.editor.toolbox.table"
  },
  {
    type: "dynamicTable",
    component: <Table />,
    toolboxComponent: "survey.editor.toolbox.dynamicTable",
    excludeFromToolbox: true
  },
  {
    type: "upload",
    component: <Upload />,
    toolboxComponent: "survey.editor.toolbox.upload",
    excludeFromToolbox: true
  },
  {
    type: "projectData",
    component: <ProjectData />,
    toolboxComponent: "survey.editor.toolbox.projectData"
  }
];
export default questionTypes;
